export const ASSISTANT_FILE_LIMIT = 2 * 1024 * 1024;
export const ASSISTANT_FILE_TYPES = ["text/plain", "application/pdf", "image/png", "image/jpeg", "image/webp"];

export const assistantFileType=file=>file.type||(/\.txt$/i.test(file.name||'')?'text/plain':'');

export function validateAssistantFiles(files) {
  if (files.length > 3) return "Voit liittää enintään 3 tiedostoa kerralla.";
  if (files.some(file => !ASSISTANT_FILE_TYPES.includes(assistantFileType(file)))) return "Valitse TXT-, PDF-, PNG-, JPEG- tai WebP-tiedosto. HEIC-kuvan voit muuntaa JPEG-muotoon tai ottaa kuvakaappauksen.";
  if (files.some(file => !file.size || file.size > ASSISTANT_FILE_LIMIT)) return "Yksi liite saa olla enintään 2 Mt eikä tiedosto voi olla tyhjä.";
  return "";
}

export async function encodeAssistantFiles(files) {
  const error = validateAssistantFiles(files);
  if (error) throw new Error(error);
  return Promise.all(files.map(file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Tiedostoa ei voitu lukea."));
    reader.onload = () => resolve({name:file.name.slice(0,120), content_type:assistantFileType(file), data_base64:String(reader.result).split(",")[1]});
    reader.readAsDataURL(file);
  })));
}
